/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, February 22nd 2022, 2:32:23 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import { ProcessDefinition, FormConfiguration } from "lib/schemas";
import { ServiceBuilderAction, IProcessDefinitionPatchState } from "./actionCreators";

interface IProcessDefinitionContext {
  currentProcessDefinition: ProcessDefinition;
  newStatusForCurrentProcessDefinition: ProcessDefinition["status"];
  isFetchingProcessDefinition: boolean;
  processDefinitionFetchHasError: boolean;
  fetchProcessDefinitionStatusCode: number;
  processDefinitionPatchState: IProcessDefinitionPatchState;
}

export interface IFormBuilderContext {
  currentFormConfiguration: FormConfiguration;
}

export interface IServiceBuilderContext {
  processDefinitionContext: IProcessDefinitionContext;
  formBuilderContext: IFormBuilderContext;
  dispatchServiceBuilderAction: React.Dispatch<ServiceBuilderAction>;
  updateTemplateArtifactsOnAPISaveFormConfiguration: (
    updatedFormconfiguration: FormConfiguration,
    update_as: FormConfiguration["form_type"],
    onSave?: (processDef: ProcessDefinition) => void
  ) => void;
  removeFormFromProcessDefinition: (form: FormConfiguration, remove_as: FormConfiguration["form_type"]) => void;
  patchCurrentProcessDefinition: (patchedData: Partial<Omit<ProcessDefinition, "id">>) => void;
}

export const ServiceBuilderContext = React.createContext<IServiceBuilderContext>({
  processDefinitionContext: null,
  formBuilderContext: null,
  dispatchServiceBuilderAction: null,
  updateTemplateArtifactsOnAPISaveFormConfiguration: null,
  removeFormFromProcessDefinition: null,
  patchCurrentProcessDefinition: null,
});

export const useServiceBuilderContext = () => {
  return React.useContext<IServiceBuilderContext>(ServiceBuilderContext);
};
